












































































import { defineComponent, reactive, SetupContext, computed } from '@vue/composition-api';
import EntityDialog from '@/components/common/EntityDialog.vue';
import { ColorGroup } from '@/models/entities/ColorGroup';
import { Category, CategoryPreview } from '@/models/entities/Category';
import ImageUpload from '@/components/utils/ImageUpload.vue';
import { DropdownFilter, IDropdownFilter } from '@/models/filters/Filters';
import PaginatedAutocomplete from '@/components/utils/PaginatedAutocomplete.vue';
import { ImageFile } from '@/models/entities/ImageFile';
import { FontGroup } from '@/models/entities/FontGroup';

interface Props {
  id: string;
}

interface State {
  entity: Category;
  loading: boolean;
  colorGroups: ColorGroup[];
  fontGroups: FontGroup[];
}

const Component = defineComponent({
  name: 'NewCategoryDialog',

  components: {
    EntityDialog,
    ImageUpload,
    PaginatedAutocomplete,
  },

  props: {
    id: String,
  },

  setup(props: Props, { root: { $store } }: SetupContext) {
    let category = new Category({});

    const state = reactive({
      entity: category,
      loading: computed(() => $store.getters['categoriesModule/loading']),
      colorGroups: computed(() => $store.getters[`colorGroupsModule/items`]),
      fontGroups: computed(() => $store.getters[`fontGroupsModule/items`]),
    }) as State;

    const rules = {
      name: [(v: string) => !!v || 'Name is required'],
      image: [(v: ImageFile) => (v && v.url !== '') || 'Image is required'],
    };

    function setNewCategory(newCategory: CategoryPreview) {
      state.entity.parentCategory = newCategory;
    }

    function setNewColorGroup(newColorGroup: ColorGroup) {
      state.entity.colorGroup = newColorGroup;
    }

    function setNewFontGroup(newFontGroup: FontGroup) {
      state.entity.fontGroup = newFontGroup;
    }

    const categoryFilterDropdown: IDropdownFilter = new DropdownFilter({
      label: 'Parent Category',
      itemsModuleName: 'categoriesModule',
    });
    const colorGroupFilterDropdown: IDropdownFilter = new DropdownFilter({
      label: 'Color Group',
      itemsModuleName: 'colorGroupsModule',
    });
    const fontGroupFilterDropdown: IDropdownFilter = new DropdownFilter({
      label: 'Font Group',
      itemsModuleName: 'fontGroupsModule',
    });

    return {
      state,
      rules,
      setNewCategory,
      setNewColorGroup,
      setNewFontGroup,
      categoryFilterDropdown,
      colorGroupFilterDropdown,
      fontGroupFilterDropdown,
    };
  },
});
export default Component;
